import { SvgIcon } from '@mui/material';
import { FC } from 'react';

const Search: FC = () => (
  <SvgIcon fontSize="inherit">
    <svg fill="none" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="Nuevo_símbolo_102_1_" transform="matrix(.80816 0 0 .80816 -278.86 -638.88)">
        <path
          // eslint-disable-next-line max-len
          d="m369.26 811.9c-0.85-0.9-2.36-2.28-3.71-3.48 3.15-4.24 2.91-10.25-0.85-14.22-4.21-4.44-11.22-4.62-15.66-0.41s-4.62 11.22-0.41 15.66c3.76 3.96 9.75 4.52 14.15 1.6 1.13 1.42 2.42 2.99 3.28 3.89 1.93 2.03 4.35 4.07 5.76 5.26 0.22-0.17 0.72-0.62 1.23-1.1 0.5-0.48 0.98-0.96 1.16-1.17-1.12-1.47-3.02-4-4.95-6.03zm-18.65-4.33c-3.17-3.34-3.03-8.63 0.31-11.8s8.63-3.03 11.8 0.31c2.79 2.95 3.01 7.41 0.73 10.59-0.24 0.19-0.7 0.61-1.18 1.06-0.47 0.45-0.92 0.89-1.12 1.12-3.3 2.12-7.75 1.67-10.54-1.28z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default Search;
